import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './TransparencySlider.css';

const TransparencySlider = ({ opacity, onChangeOpacity }) => {
  const [sliderValue, setSliderValue] = useState(opacity); // Mantener el valor del slider en el estado local
  const { t } = useTranslation(); // hook para usar la función de traducción

  const handleSliderChange = (event) => {
    const newOpacity = parseFloat(event.target.value); // Obtener el nuevo valor del slider
    setSliderValue(newOpacity); // Actualizar el valor local del slider
    onChangeOpacity(newOpacity); // Pasar el valor actualizado al componente padre
  }

  return (
    <div className='slider-container'>
      <input
        type='range'
        className='form-range slider-opacity'
        value={sliderValue}
        min={0}
        max={1}
        step={0.01} // El paso ahora es 0.01 en lugar de 0.1. Esto proporcionará una mayor precisión al cambiar el valor del slider, y se evitará que el valor "rebote" en los extremos.
        onChange={handleSliderChange}
        title={t('Layer transparency level')}
        style={{ paddingTop: '5px' }}
        />
      {/* <div className="opacity-value">{(sliderValue * 100).toFixed(0)}%</div> Mostrar el valor de opacidad en porcentaje */}
    </div>
  );
}

export default TransparencySlider;
